module.exports = __webpack_public_path__ + "img/fa-regular-400.4689f52.svg";